<template>
  <div class="transition">
    <BasicText size="h5">Quelle est la convention collective de cet établissement ?</BasicText>
    <WrapperAutocomplete
      v-model="data"
      :search
      key-id="code"
      key-label="intitule"
      :get-item-label="formatIdcc"
      placeholder="Idcc ou intitulé ..."
      emptyResultLabel="L’IDCC saisi est incorrect ou ne semble pas faire partie du champ de compétences d’Akto"
      :search-min-length="0"
      label="Idcc de l'établissement"
      strict
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { IdccDTO } from '@/features/api/extranet/dto/Lov'
  import type { EtablissementAdherentDTO } from '@/features/api/extranet/dto/shared'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import services from '@/features/services/demande/DemandeAllService'
  import { isNullUndefinedOrEmptyString } from '@/features/shared/tools'

  const props = defineProps<CarteProps<EtablissementAdherentDTO, IdccDTO>>()
  const emits = defineEmits<CarteEvents<IdccDTO>>()

  const data = computed<IdccDTO | undefined>({
    get: () => props.out,
    set: (value) => {
      const outReady = !isNullUndefinedOrEmptyString(value?.code)
      emits('outChanged', outReady, value)
    },
  })

  const search = (query: string) => {
    return services.searchIdcc(
      {
        search: query.toLowerCase(),
        codePostal: props.in.adresse?.codePostal,
        estChampAkto: true,
      },
      { dialogMode: 'silent', sablier: false },
    )
  }

  const formatIdcc = function (idcc: IdccDTO) {
    return `${idcc.code} - ${idcc.intitule}`
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
